<script setup lang="ts">
import InputGroup from 'primevue/inputgroup';
import { inject } from 'vue';

import { InputGroupProps } from './InputGroup.vue.d';

defineProps<InputGroupProps>();

const Preset = inject<Record<string, any>>('preset', {}).inputgroup;

const focusToInput = (e: MouseEvent): void => {
  const target = e.target as HTMLElement;
  if (target) {
    const el = target.querySelector('input') as HTMLInputElement;

    el?.focus();
  }
};
</script>

<template>
  <slot v-if="$attrs['use-input-group'] == false" />

  <InputGroup
    v-else
    v-bind="Preset.root({ props: { ...$props, class: $attrs['class'] } })"
    @click="focusToInput"
  >
    <slot />
  </InputGroup>
</template>
